<template>
  <!-- 融合全攻略-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo19" :type="'rhqgl'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo19 from '@/assets/images/logo19.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo19
    }
  }
}
</script>